/** @format */

import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useLocale } from "./i18n/hooks";
import { Locale, locales } from "./i18n/init";
import LocaleWrapper from "./i18n/LocaleWrapper";
import App from "./App";
import resourcesRoutes from "./features/resources/resourcesRoutes";
import userRoutes from "./features/user/userRoutes";
import authRoutes from "./features/auth/authRoutes";
import PageNotFound from "./features/pageNotFound/PageNotFound";
import AuthFlag from "./features/auth/AuthFlag";
import adminRoutes from "./features/admin/adminRoutes";

const RedirectToLocale: React.FC<{ currentLocale: Locale }> = ({
  currentLocale,
}) => {
  const location = useLocation();

  if (location.pathname.match(new RegExp(`/${currentLocale}`))) {
    return <Navigate to={`/404`} />;
  } else {
    return (
      <Navigate
        to={`${currentLocale}${location.pathname}${location.search}${location.hash}`}
      />
    );
  }
};

const AppRouter: React.FC = () => {
  const currentLocale = useLocale();

  const router = createBrowserRouter([
    {
      path: "*",
      errorElement: <App />,
      children: [
        {
          index: true,
          element: <Navigate to={currentLocale} />,
        },
        ...locales.map((locale) => ({
          path: locale,
          element: <LocaleWrapper key={locale} locale={locale} />,
          children: [
            {
              element: <App />,
              children: [
                ...resourcesRoutes,
                {
                  path: "user",
                  children: userRoutes,
                },
                {
                  path: "auth",
                  children: authRoutes,
                },
                {
                  path: "admin",
                  element: <AuthFlag authGroup={["admin", "wjec"]}><Outlet /></AuthFlag>,
                  children: adminRoutes,
                },
                {
                  path: "404",
                  element: <PageNotFound itemName="Page" />,
                },
              ],
            },
          ],
        })),
        {
          path: "*",
          element: <RedirectToLocale currentLocale={currentLocale} />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRouter;
